import React, { Component } from 'react'
import Zoom from 'react-reveal/Zoom'
import Fade from 'react-reveal/Fade'
import Slide from 'react-reveal/Slide'
import TransitionGroup from 'react-transition-group/TransitionGroup'
import HouseBg from '../assets/house/house-bg.png'
import House1 from '../assets/house/house-1.png'
import House2 from '../assets/house/house-2.png'
import House3 from '../assets/house/house-3.png'
import styled from 'styled-components'

const SlideWrapper = styled.div`
  .house-container {
    margin-top: -15px;
    margin-bottom: -35px;
  }

  .text-left {
    @media screen and (min-width: 768px) {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    @media screen and (max-width: 768px) {
      justify-content: end;
    }
    padding-bottom: 100px;

    > div {
      padding: 20px;
      border-radius: 10px;
      transition: box-shadow 500ms ease;
      transition: background-color 500ms ease;
    }
    > div {
      &:hover {
        background-color: #07323e;
        box-shadow: 5px 5px 5px #000;
      }
    }

    .next {
      margin-top: 2rem;
      cursor: pointer;

      a {
        border-bottom: 1px solid transparent;
        transition: border 300ms;
        &:hover {
          border-bottom: 1px solid #7ecfd1;
        }
      }
    }
  }

  > .columns {
    @media screen and (max-width: 768px) {
      display: flex;
      flex-direction: column-reverse;

      .text-left {
        z-index: 5;
        > div {
          background-color: #07323e;
          box-shadow: 5px 5px 5px #000;
        }
      }
    }
  }

  .pagination-dots {
    span {
      padding: 0 1rem;

      cursor: pointer;
    }
  }
`

class Approach extends Component {
  constructor(props) {
    super(props)
    this.groupProps = {
      appear: true,
      enter: true,
      exit: true,
    }
    this.state = {
      progress: 1,
    }
    this.tickForward = this.tickForward.bind(this)
    this.reset = this.reset.bind(this)
    this.update = this.update.bind(this)
  }

  tickForward() {
    this.setState({
      progress: this.state.progress + 1,
    })
  }
  update(num) {
    this.setState({
      progress: num,
    })
  }
  reset() {
    this.setState({
      progress: 1,
    })
  }

  render() {
    return (
      <SlideWrapper className="container">
        <div className="columns">
          {this.state.progress == 1 && (
            <div className="text-left column is-half">
              <div>
                <h4 className="title is-size-4 has-text-white">
                  1. Foundation
                </h4>
                <p className="has-text-white has-text-weight-semibold">
                  The cornerstone of an effective market growth strategy starts
                  with your brand. A brand is more than just a label or logo,
                  it's everything that potential clients associate with your
                  business. We position your business message to align with your
                  target market and craft your marketing efforts around their
                  needs.
                </p>
                <div className="next" onClick={this.tickForward}>
                  <a className="button is-link">Structure →</a>
                </div>
              </div>
            </div>
          )}
          {this.state.progress == 2 && (
            <div className="text-left column is-half">
              <div>
                <h4 className="title is-size-4 has-text-white">2. Structure</h4>
                <p className="has-text-white has-text-weight-semibold">
                  Building an effective website means planning for the future.
                  Websites should be built to grow and adjust to your marketing.
                  We have experience designing digital marketing tools to
                  achieve business growth and long-term goals.
                </p>
                <div className="next" onClick={this.tickForward}>
                  <a className="button is-link">Outreach →</a>
                </div>
              </div>
            </div>
          )}
          {this.state.progress == 3 && (
            <div className="text-left column is-half">
              <div>
                <h4 className="title is-size-4 has-text-white">3. Outreach</h4>
                <p className="has-text-white has-text-weight-semibold">
                  A website without Marketing is like renting a storefront on
                  the moon -- it's cool, but it's hard for your customer to
                  find. SEO and Online Advertising are the highways that connect
                  customers to your business.
                </p>
                <div className="next" onClick={this.reset}>
                  <a className="button is-link">Foundation →</a>
                </div>
              </div>
            </div>
          )}

          <div className="column is-half">
            <div />

            <div className="house-container">
              <TransitionGroup {...this.groupProps}>
                <Fade ssrFadeout delay={1000}>
                  <img className="house" src={HouseBg} alt="" />
                </Fade>
                {this.state.progress >= 1 && (
                  <Zoom ssrFadeout delay={2000}>
                    <img className="house" src={House1} alt="" />
                  </Zoom>
                )}
                {this.state.progress >= 2 && (
                  <Fade right ssrFadeout>
                    <img className="house" src={House2} alt="" />
                  </Fade>
                )}
                {this.state.progress >= 3 && (
                  <Slide bottom ssrFadeout>
                    <img className="house" src={House3} alt="" />
                  </Slide>
                )}
              </TransitionGroup>
            </div>
            {/* <BuildingAnimation /> */}
          </div>
        </div>
        <div className="pagination-dots has-text-centered">
          <span
            onClick={this.update.bind(this, 1)}
            className={
              this.state.progress == 1
                ? 'has-text-primary is-size-2'
                : 'has-text-white is-size-2'
            }
          >
            •
          </span>
          <span
            onClick={this.update.bind(this, 2)}
            className={
              this.state.progress == 2
                ? 'has-text-primary is-size-2'
                : 'has-text-white is-size-2'
            }
          >
            •
          </span>
          <span
            onClick={this.update.bind(this, 3)}
            className={
              this.state.progress == 3
                ? 'has-text-primary is-size-2'
                : 'has-text-white is-size-2'
            }
          >
            •
          </span>
        </div>
      </SlideWrapper>
    )
  }
}

export default Approach



// WEBPACK FOOTER //
// ./src/components/approach.js